import { render, staticRenderFns } from "./LocationAdditionalChargeDetails.vue?vue&type=template&id=5bfe25cf&scoped=true&"
import script from "./LocationAdditionalChargeDetails.vue?vue&type=script&lang=js&"
export * from "./LocationAdditionalChargeDetails.vue?vue&type=script&lang=js&"
import style0 from "./LocationAdditionalChargeDetails.vue?vue&type=style&index=0&id=5bfe25cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfe25cf",
  null
  
)

export default component.exports